import React, { useEffect, useState } from "react";
import { setFavicon } from "../../utils/setFavicon";
import { setTitle } from "../../utils/setTitle";

import Navbar0 from "./Navbar/Navbar0";
import Navbar1 from "./Navbar/Navbar1";
import Navbar2 from "./Navbar/Navbar2";
import Navbar3 from "./Navbar/Navbar3";
import Footer0 from "./Footer/Footer0";
import Footer1 from "./Footer/Footer1";
import Footer2 from "./Footer/Footer2";
import Footer3 from "./Footer/Footer3";
import axios from "axios";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import loader from "../../assets/loader.gif";
import PincodeModal from "../PincodeModal";


// import { useParams } from "react-router-dom";

const footers = {
  0: Footer0,
  1: Footer1,
  2: Footer2,
  3: Footer3,
};

const navbars = {
  0: Navbar0,
  1: Navbar1,
  2: Navbar2,
  3: Navbar3,
};

// Loader Component
const Loader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <img src={loader} alt="Loading..." className="w-30 h-30" />
  </div>
);




const Layout = () => {
//   const DEV_NAVBAR_TEST = true; // turn false later
// const DEV_NAVBAR_NO = ; // 0 / 1 / 2 / 3
const [isMobile, setIsMobile] = useState(false);


  const subdomain = "grobiz";
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [footerEnabled, setFooterEnabled] = useState(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    return storedStyle
      ? JSON.parse(storedStyle).footer_enabled === "true"
      : false;
  });

  
  const [footerNo, setFooterNo] = useState(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    return storedStyle ? Number(JSON.parse(storedStyle).footer_no) || 0 : null;
  });

  const [navbarNo, setNavbarNo] = useState(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    return storedStyle ? Number(JSON.parse(storedStyle).navbar_no) || 0 : null;
  });
  const [showModal, setShowModal] = useState(false);

  const fetchAppUIStyle = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get_app_ui_style`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
        }),
      });

      if (!response.ok) throw new Error("Failed to fetch data");

      const data = await response.json();
      console.log("UI Style API Response:", data);
      const styleData = data.all_app_ui_style[0];

      sessionStorage.setItem("UIStyle", JSON.stringify(styleData));
      setFooterNo(Number(styleData.footer_no) || 0);
      setNavbarNo(Number(styleData.navbar_no) || 0);
      setFooterEnabled(styleData.footer_enabled === "true");

      // Check for accessToken and userPincode after UI style is fetched
      const userPincode = sessionStorage.getItem("userPincode");
      if (!userPincode) {
        setShowModal(true); 
      }
    } catch (error) {
      console.error("Error fetching app UI style:", error);
    }
  };
  useEffect(() => {
  const storedTitle = sessionStorage.getItem("appName");
  if (storedTitle) {
    setTitle(storedTitle);
  }
}, []);

  useEffect(() => {
  const storedLogo = sessionStorage.getItem("appLogo");
  if (storedLogo) {
    setFavicon(storedLogo);
  }
}, []);

  useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth < 768);
  };

  checkMobile(); // initial check
  window.addEventListener("resize", checkMobile);

  return () => window.removeEventListener("resize", checkMobile);
}, []);

  useEffect(() => {
    const adminAutoId = sessionStorage.getItem("admin_auto_id");
    const appTypeId = sessionStorage.getItem("app_type_id");

    // If admin/appType not present in sessionStorage, fetch using subdomain
    if (!adminAutoId || !appTypeId) {
      if (subdomain) {
        axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/get_admin_by_domain`,
            {
              subdomain: subdomain,
            }
          )
          .then((response) => {
  console.log("Admin data:", response.data);

  if (response.data.status === 0) {
      navigate("/404");
      return;
    }

    if (response.data.status === 1) {
      const adminAutoId = response.data.data._id;
      const appTypeId = response.data.data.category_id;
      const app_logo = response.data.data.app_logo;
      const app_name = response.data.data.app_name;

      // ✅ SAVE DATA TO SESSION
      sessionStorage.setItem("admin_auto_id", adminAutoId);
      sessionStorage.setItem("app_type_id", appTypeId);
      sessionStorage.setItem("appLogo", app_logo);
      sessionStorage.setItem("appName", app_name);

      // ✅ SET BROWSER TAB ICON + TITLE
      setFavicon(app_logo);
      setTitle(app_name);

      //  FETCH UI STYLE AFTER BRANDING IS READY
      fetchAppUIStyle();
    }
})

          .catch((error) => {
            console.error("Error fetching admin data:", error);
            navigate("/404");
          });
      }
    }
    // If footerNo or navbarNo are not set, fetch UI style
    if (footerNo === null || navbarNo === null) {
      fetchAppUIStyle();
    } else {
      // Refresh footer enabled state from sessionStorage
      const storedStyle = sessionStorage.getItem("UIStyle");
      if (storedStyle) {
        setFooterEnabled(JSON.parse(storedStyle).footer_enabled === "true");
      }
      // Check for accessToken and userPincode if UI style is already set

      const userPincode = sessionStorage.getItem("userPincode");
      if (!userPincode) {
        setShowModal(true); 
      }
    }
  }, [subdomain, navigate, footerNo, navbarNo]);

  if (footerNo === null || navbarNo === null) {
    return <Loader />; // Show loader while fetching data
  }

  console.log(sessionStorage.getItem("UIStyle"));

  const SelectedFooter = footers[footerNo] || Footer0;
  // const SelectedNavbar = navbars[navbarNo] || Navbar0; 
  // const SelectedNavbar = DEV_NAVBAR_TEST
  // ? navbars[DEV_NAVBAR_NO] || Navbar0
  // : navbars[navbarNo] || Navbar0;
  const SelectedNavbar = isMobile
  ? Navbar2
  : navbars[navbarNo] || Navbar0;

  

  return (
    <div className="flex flex-col">
      <SelectedNavbar />
      <div className="flex-1 min-h-screen bg-white">
        <Outlet class />
      </div>
      {footerEnabled && <SelectedFooter />}
      <PincodeModal showModal={showModal} setShowModal={setShowModal} />
    </div>
  );
};

export default Layout;
